<template>
  <div class="invoice-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Cobranças &raquo; Lista de {{ termPlural }}</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
<!--              <b-col cols="auto">-->
<!--                <router-link v-if="canAdd" tag="a" class="btn btn-primary btn-sm mr-2" :to="'/cobrancas/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar {{ termSingular }}</router-link>-->
<!--              </b-col>-->
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
          <b-row class="mb-2">
            <b-col>
              <label class="cj-label">Período</label>
              <date-range-picker
                  class="w-100"
                  ref="picker"
                  :localeData="dateRangePickerPtBrLocale"
                  :timePicker="false"
                  :timePicker24Hour="false"
                  :showDropdowns="true"
                  :ranges="false"
                  :showWeekNumbers="false"
                  :opens="'right'"
                  v-model="invoiceFilterForm.dateTime">
                <div slot="input" slot-scope="picker" class="">
                  {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}
                </div>
              </date-range-picker>
            </b-col>
            <b-col>
              <label class="cj-label">Conta de cobrança</label>
              <multiselect v-model="invoiceFilterForm.seller" :options="sellers" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione"></multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Status</label>
              <multiselect v-model="invoiceFilterForm.status" :options="invoiceStatusOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="false" placeholder="Selecione"></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label class="cj-label">ID da transação</label>
              <b-form-input type="text" v-model="invoiceFilterForm.zoopId"></b-form-input>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getInvoices(1)"><i class="far fa-search"></i> Filtrar</b-button>
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de {{ termPlural }}</p>
                  <p class="title"><small>{{ pagination.total }} {{ termPlural }} cadastrad{{ letter }}s</small></p>
                </div>
              </div>
              <div class="content">

                <div v-if="pagination.lastPage > 1">
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getPeople"></b-pagination>
                  <hr>
                </div>

                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                    <tr>
<!--                      <th>ID</th>-->
                      <th>Data</th>
                      <th>Paciente</th>
                      <th>Método de pagamento</th>
                      <th>Valor</th>
                      <th>Tarifa</th>
                      <th>Identificador</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <router-link tag="tr" :to="'/cobrancas/'+url+'/'+invoice.id" v-for="invoice in invoices" :key="invoice.id">
<!--                      <td>{{ invoice.zoop_id }}</td>-->
                      <td>{{ moment(invoice.created_at).format('DD/MM/YYYY') }}</td>
                      <td>{{ invoice.patient != null ? invoice.patient : '-' }}</td>
                      <td>{{ invoice.payment_method == 'boleto' ? 'Boleto' : (invoice.card_brand + ' ' + invoice.card_bin + ' ****') }}</td>
                      <td>R$ {{ formatPrice(invoice.value_in_cents/100.0) }}</td>
                      <td>{{ invoice.fees_in_cents != null ? ('R$ ' + formatPrice(invoice.fees_in_cents/100.0)) : '-' }}</td>
                      <td>{{ invoice.payment_method == 'boleto' ? invoice.boleto_document_number : (invoice.card_nsu != null ? (invoice.card_nsu + '-' + invoice.card_auth) : '') }}</td>
                      <td>{{ invoiceStatusOptions.find(g => g.value == invoice.status).name }}</td>
                    </router-link>
                  </tbody>
                </table>
                <p v-if="invoices.length == 0" class="text-center sub-title">A sua busca por {{ termSingular }} não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getInvoices"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'transação',
        termPlural: 'transações',
        url: 'transacoes',
        letter: 'a',
        newTerm: 'cadastrar-transacao',
        module: 'sellers',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        invoiceStatusOptions: [
          { value: 'new', name: 'Novo' },
          { value: 'pending', name: 'Pendente' },
          { value: 'pre_authorized', name: 'Pré-autorizado' },
          { value: 'succeeded', name: 'Pago' },
          { value: 'failed', name: 'Recusado' },
          { value: 'reversed', name: 'Revertido' },
          { value: 'canceled', name: 'Cancelado' },
          { value: 'refunded', name: 'Reembolsado' },
          { value: 'dispute', name: 'Em disputa' },
          { value: 'charged_back', name: 'Devolvido' }
        ],

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,

        invoices: [],

        sellers: [],

        invoiceFilterForm: {
          dateTime: { startDate: this.moment().startOf('month'), endDate: this.moment().endOf('month') },
          status: null,
          zoopId: ''
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        }
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_remove');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' });
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      await this.api.getSellers({status: 'enabled', all: true}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.sellers = [];
        res.data.forEach(seller => {
          this.sellers.push({value: seller.id, name: seller.company_document != null ? seller.company_name : seller.name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Sellers', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as contas de cobrança da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Sellers', err.response);
      });

      this.getInvoices(this.pagination.currentPage);
    },
    methods: {
      getInvoices(page) {
        let invoiceFilterData = {
          start_date: this.moment(this.invoiceFilterForm.dateTime.startDate).format('YYYY-MM-DD'),
          end_date: this.moment(this.invoiceFilterForm.dateTime.endDate).format('YYYY-MM-DD'),
          zoop_id: this.invoiceFilterForm.zoopId,
          status: (this.invoiceFilterForm.status != null)?this.invoiceFilterForm.status.value:null,
          seller_id: (this.invoiceFilterForm.seller != null)?this.invoiceFilterForm.seller.value:null,
          page: page
        };

        this.api.getInvoices(invoiceFilterData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.invoices = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Invoices', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar as transações da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Invoices', err.response);
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .invoice-list {
    padding: 20px 0;

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }

          td {
            font-size: 14px;
          }
        }
      }
    }
  }
</style>
